import type { IDailyStatisticsState } from 'models/ICattlesData'

/**
 * Mock для превью IdentificateWidget, IdentificateWithNotif, IdentificateWithNotifMedium.
 */
export const DAILY_STATISTICS_MOCK: IDailyStatisticsState = {
	issues: {
		repeat_identification: false,
	},
	identified_count: {
		value: 115,
		out_of: 120,
		unidentified: 5,
	},
	milking_data: {
		today_total: 2450,
		today_average: 20.4,
		yesterday_at_this_time: 2300,
		yesterday_at_this_time_average: 19.2,
		yesterday_average: 19.5,
		yesterday_total: 2340,
	},
	fatness_data: [],
	limpness_data: [],
}
